import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getGradeList } from "../../actions/Grade.action";
import StudentPortfolio from "../../components/StudentPortfolio/StudentPortfolio";
import Layout from "../../components/shared/Layout/Layout";

const StudentPortfolioPage = ({ grades, getGradeList }) => {
  useEffect(() => {
    if (grades === null) {
      getGradeList();
    }
  }, []);

  return (
    <div className="bg_light">
      <Layout title="Student Portfolio">
        <StudentPortfolio grades={grades ? grades : []} />
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(StudentPortfolioPage);
